
export default {
  0: "校招",
  1: "社招",
}


// WEBPACK FOOTER //
// ./src/enum/positionType.js